var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5137 6.45117L6 11.9648L0.486328 6.45117L1.01367 5.92383L5.625 10.5352V0H6.375V10.5352L10.9863 5.92383L11.5137 6.45117Z",
    fill: "#0078d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescSort);
export default __webpack_public_path__ + "static/media/descSort.1dbef7c6fb81a73314c5c66d5ccf72d7.svg";
export { ForwardRef as ReactComponent };